import { RootState } from '@/store'

export const getUsersToAdd = (state: RootState) => {
  return state.organizationUsersBulkAddPage.usersToAdd || []
}

export const getFailedUsers = (state: RootState) => {
  return state.organizationUsersBulkAddPage.failed || []
}

export const getCreatedUsers = (state: RootState) => {
  return state.organizationUsersBulkAddPage.created || []
}

export const getInfoUsers = (state: RootState) => {
  return state.organizationUsersBulkAddPage.info || []
}

export const getCsvData = (state: RootState) => {
  return state.organizationUsersBulkAddPage.csvData || [[]]
}

export const getIsProcessingCsv = (state: RootState) => {
  return state.organizationUsersBulkAddPage.isProcessingCsv || false
}
